import type { AppNotification } from '../services/api';

/** Mirrors the API: coach requests require an explicit accept/decline action. */
export function markNotificationGroupsRead(groups: Record<string, AppNotification[]>): Record<string, AppNotification[]> {
  return Object.fromEntries(Object.entries(groups).map(([date, items]) => [date, items.map(item =>
    item.notifiable_type === 'CoachAthleteRequest' ? item : { ...item, is_read: true },
  )]));
}
